import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/footer";
import SEOHead from "../SEO/SEOHead";
import { PageHero } from "../common/ui";
import UpcomingReleases from "./UpcomingReleases";
import ReleaseNotes from "./ReleaseNotes";
import fallback from "./changelogFallback.json";
import { fetchChangelog } from "../services/changelogApi";
import "../../css/MainPage.css";
import "../../css/ReleaseNotes.css";

// Live data comes from the backend (edited at /admin/change-log).
// If the backend can't be reached, the copy bundled with the site is shown instead.
function useChangelog() {
  const [state, setState] = useState({ data: null, loading: true });

  useEffect(() => {
    let active = true;
    fetchChangelog()
      .then(data => {
        if (!active) return;
        const valid = data && Array.isArray(data.releases);
        setState({ data: valid ? data : fallback, loading: false });
      })
      .catch(() => {
        if (active) setState({ data: fallback, loading: false });
      });
    return () => {
      active = false;
    };
  }, []);

  return state;
}

const ChangeLog = () => {
  const { data, loading } = useChangelog();

  return (
    <>
      <SEOHead
        title="Software Test Management Release Notes and Updates"
        description="Stay updated with software test management release notes and updates, highlighting new features, fixes, and improvements to streamline QA and testing."
        keywords="software test management release notes, Froth TestOps change log"
      />
      <div className="fd-main-wrapper page-padding">
        <Header />
        <main>
          <PageHero
            crumbs="Change Log"
            eyebrow="Change Log"
            title={
              <>
                What's new in <span>Froth TestOps</span>
              </>
            }
            lead="We are constantly working on improving Froth TestOps to serve your testing needs. This change log keeps you informed about the latest updates and improvements to the platform."
          />
          <section className="ft-section" id="releases">
            <div className="ft-container" aria-busy={loading}>
              {loading ? (
                <div className="cl-loading" role="status">
                  <span className="cl-loading__bar" />
                  <span className="cl-loading__bar" />
                  <span className="cl-loading__bar" />
                  <span className="visually-hidden">Loading release notes…</span>
                </div>
              ) : (
                <>
                  <UpcomingReleases items={data.upcoming} />
                  <ReleaseNotes releases={data.releases} />
                </>
              )}
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ChangeLog;
